module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA8UlEQVR4AWOgC4gv2jBt6WVH75Q3B9n+X2L4fwYdAQV5tTuACKpBy2VaTMH6uJL9MclFrw6wAqUJaGBTbRXU75q76rxl6LrgmLx3R9iBKvBogHHkG/vmnCjtPG3pmgjWQ0gDl0a7nOWEgLQV7TMvewZlgt2GWwMEsSg3qztOLWrZ6Z64NT695DU8DDA1wBGnehurasuyjZfdErYA7Xl3FOw2TA1oiE21pax9d8esK1auiW8Ps/+/QUgDu1or0G1+KStKOk6Bwu0YEwENfCD/tMhaTuieedQ0cE1KRjYeDQjEo9XOrtZW2rbbM3ENVMOgBADd2bmDpfJWXAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BA.png
// module id = 1084
// module chunks = 0